import { InnerContainer } from './components/InnerContainer/InnerContainer.js';
import { InnerDonut } from './components/InnerDonut/InnerDonut.js';

export interface InnerWrapperProps {
  width: number;
  height: number;
  innerRadius: number;
  visibleIds: string[];
}

export const InnerWrapper = ({
  width,
  height,
  innerRadius,
  visibleIds,
}: InnerWrapperProps) => {
  // Formula to calculate the maximum square inside a circle =  √2 × radius
  const donutInner = Math.sqrt(2) * innerRadius;

  return (
    <InnerContainer donutInner={donutInner} height={height} width={width}>
      <InnerDonut donutInner={donutInner} visibleIds={visibleIds} />
    </InnerContainer>
  );
};
